import { useMemo } from 'react';

/**
 * Função para gerar cores distintas para profissionais
 * @param {number} index - Índice do profissional
 * @returns {string} - Código hexadecimal da cor
 */
export const generateProfessionalColor = (index) => {
  // Array de cores distintas para profissionais
  const professionalColors = [
    '#3B82F6', // Azul
    '#F59E0B', // Âmbar
    '#10B981', // Verde
    '#8B5CF6', // Violeta
    '#EC4899', // Rosa
    '#06B6D4', // Ciano
    '#F97316', // Laranja
    '#14B8A6', // Turquesa
    '#6366F1', // Índigo
    '#D946EF', // Fúcsia
    '#0EA5E9', // Azul claro
    '#84CC16'  // Verde limão
  ];
  
  // Usar index modulo o tamanho do array para sempre ter uma cor válida
  return professionalColors[index % professionalColors.length];
};

/**
 * Hook para gerenciar os recursos (profissionais) da timeline
 * 
 * @param {Object} options - Opções para o hook
 * @param {Array} options.professionals - Lista de profissionais
 * @returns {Object} Recursos para a timeline
 */
const useTimelineResources = ({ professionals = [] }) => {
  // Garantir que professionals seja sempre um array
  const professionalsArray = Array.isArray(professionals) ? professionals : [];
  
  // Converter profissionais para recursos da timeline
  const resources = useMemo(() => {
    return professionalsArray.map((prof, index) => ({
      id: prof.id,
      title: prof.nome || `Profissional ${index + 1}`,
      avatarUrl: prof.avatarUrl || prof.foto || null,
      color: prof.color || prof.cor || generateProfessionalColor(index)
    }));
  }, [professionalsArray]);
  
  // Adicionar recurso "Qualquer Profissional"
  const resourcesWithAny = useMemo(() => {
    return [
      { 
        id: 'any', 
        title: 'Não Atribuído',
        avatarUrl: null,
        color: '#6B7280' // Cor cinza neutra para eventos gerais
      },
      ...resources
    ];
  }, [resources]);
  
  return {
    resources,
    resourcesWithAny,
    generateProfessionalColor
  };
};

export default useTimelineResources; 